import api from '@virgodev/bazaar/functions/api';

export default {
  api,
};
